import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Login from '@/components/auth/Login'
import Register from '@/components/auth/Register'
import GenerarRecibo from '@/components/RRHH/Recibo'
import GenerarConstancia from '@/components/RRHH/Constancia'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Hello,
      meta: {
        requiresAuth: true
      }
      /* ,
      children: [
        {
          path: '/',
          component: CustomersList
        },
        {
          path: 'new',
          component: NewCustomer
        },
        {
          path: ':id',
          component: Customer
        }
      ] */
    },
    {
      path: '/recibo',
      name: 'recibo',
      component: GenerarRecibo,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/constancia',
      name: 'constancia',
      component: GenerarConstancia,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ingresar',
      name: 'login',
      component: Login
    },
    {
      path: '/registro',
      name: 'register',
      component: Register
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js